import { TableCell, TableRow, Button } from '@mui/material';
import CustomTypography from '../../ui/atoms/CustomTypography';
import {
  AuditStateQuestion,
  MobileStateItemBase,
} from '@safeguardproperties/corescript-react-npm/dist/types';
import useMediaHelper from '../MainComponent/hooks/useMediaHelper';
import { useMemo, useState } from 'react';
import { useAppSelector } from '../../redux/Store';
const THUMBNAIL_SIZE = 198;

// Add this import
import { styled } from '@mui/material/styles';

// Styled image component
const Thumbnail = styled('img')({
  width: THUMBNAIL_SIZE,
  height: THUMBNAIL_SIZE,
  objectFit: 'cover',
  borderRadius: 4,
  border: '1px solid #ccc',
});

import IconImages from '../../assets/icons/IconImages';

type AiInfoProps = {
  expanded: boolean;
  question: AuditStateQuestion;
};
import ImageDialog from '../Gallery/ImageDialog';
const AiInformation = ({ expanded, question }: AiInfoProps) => {
  const uploadedImageDetails = useAppSelector(
    (state) => state.gallery.uploadedImageDetails
  ); //

  const [visible, setVisible] = useState<boolean>(false);
  const [expandedPhotos, setExpanded] = useState<boolean>(expanded);

  const { getAllImagesByQuestion } = useMediaHelper();

  const imagesAiOnly = useMemo(() => {
    if (question.AiAudit?.Images) {
      //Key is the image id
      return Object.entries(question.AiAudit.Images).map(([key, url]) => ({
        key: key,
        url: url,
      }));
    }
    return [];
  }, [question]);

  const matchedMetadataImages = useMemo(() => {
    if (!imagesAiOnly || !uploadedImageDetails) return [];
    const aiKeys = new Set(imagesAiOnly.map((img) => img.key));
    const foundImages = uploadedImageDetails.filter((img) =>
      aiKeys.has(img.id)
    );
    return foundImages;
  }, [imagesAiOnly, uploadedImageDetails]);

  return (
    <>
      <TableRow sx={{}}>
        <TableCell colSpan={7} sx={{ border: 'none', padding: 1 }}>
          <CustomTypography
            variant='body1'
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '12px',
              fontWeight: 500,
              lineHeight: '14.63px',
              color: '#343330',
              cursor: 'pointer',
              textAlign: 'left',
              textTransform: 'none',
              display: '-webkit-box',
              WebkitLineClamp: 5,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordBreak: 'break-word',
              hyphens: 'auto',
            }}
          >
            {imagesAiOnly && imagesAiOnly.length > 0 && (
              <Button
                onClick={() => setExpanded(!expandedPhotos)}
                sx={{
                  minWidth: 0,
                  padding: '4px',
                  '&.Mui-disabled': {
                    cursor: 'not-allowed',
                    pointerEvents: 'all !important',
                  },
                }}
              >
                <IconImages />
              </Button>
            )}{' '}
            {question?.AiAudit?.Reasoning}
          </CustomTypography>
          {/* Display AI Audit Images */}
          <div
            onDoubleClick={() => {
              setVisible(true);
            }}
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
            }}
          >
            {expandedPhotos &&
              imagesAiOnly &&
              imagesAiOnly.map(({ key, url }) => (
                <Thumbnail
                  key={key}
                  src={String(url)}
                  alt={`AI Audit ${key}`}
                  aria-label={`Open AI Audit image ${key}`}
                />
              ))}
          </div>
        </TableCell>
      </TableRow>

      <ImageDialog
        images={matchedMetadataImages}
        open={visible}
        type='aiMedia'
        onClose={() => setVisible(false)}
      />
    </>
  );
};

export default AiInformation;
